/* eslint-disable no-undef */
(function ($) {
    RVwys.plugin['googleMap'] = true;
    RVwys.curItemMap = false;
    RVwys.footer = {};
    RVwys.widget.google = {};

    $(document).bind('editorReady', function () {
        $('.mapInput').bind('paste keyup', function (e) {
            if (RVwys.curItemMap) {
                var oFrame = RVwys.curItemMap.find('iframe');
                var cmd = $(this).attr('cmd');
                oFrame.attr(cmd, $(this).val());
                oFrame
                    .parent()
                    .find('.googlemapOverlay')
                    .css({
                        width: oFrame.attr('width'),
                        hegith: oFrame.attr('height'),
                        'margin-top': '-' + oFrame.attr('height') + 'px',
                    });
            }
        });
        $('.insert-embed-map').bind('paste keyup', function (e) {
            // access the clipboard using the api
            //alert(event.type)
            console.log('insert-embed-map' + e.type);
            var pastedData =
                e.type == 'paste'
                    ? e.originalEvent.clipboardData.getData('text')
                    : $(this).val();
            var pat = RegExp(
                '^<iframe.*?(?:www.google.com/maps).*?</iframe>$',
                'img'
            );
            if (pastedData.match(pat)) {
                //alert(RVwys.curItemMap.get(0))
                RVwys.curItemMap.find('iframe').remove();
                RVwys.curItemMap.find('.overlaypanel').remove();
                RVwys.curItemMap.html(pastedData);
                var oFrame = RVwys.curItemMap.find('iframe');
                var position = oFrame.position();
                parent
                    .$('.googleMapWidth')
                    .val(oFrame.attr('width', '100%').attr('width'));
                parent.$('.googleMapHeight').val(oFrame.attr('height'));

                RVwys.curItemMap.append(
                    $(
                        '<div class="jsgooglemap uk-overlay-panel" onclick="RVwys.panelGoogleMap(this);"></div>'
                    ).css({
                        //'width':oFrame.attr('width'),
                        //'height':oFrame.attr('height'),
                        //'margin-top':'-'+oFrame.attr('height')+'px'
                    })
                );
            }
            // alert(pastedData);
        });
    });
    $(document).bind('designReady', function (e) {
        $('#widgetGoogleMap')
            .disableSelection()
            .sortable({
                connectWith: '.editable_area',
                cancel: '.consonant',
                opacity: '.5',
                appendTo: 'body',
                sort: function (e, ui) {
                    RVwys.hidemgActive();
                },
                placeholder: {
                    element: function (e, li) {
                        return $($('.tpl-placeholder').html())[0];
                    },
                    update: function (e, li) {
                        return;
                    },
                },
                helper: function (e, li) {
                    this.copyHelper = li.clone().insertAfter(li);
                    $(this).data('copied', false);
                    return $(
                        '<div class ="rvSWDhelper" style="width:200px;border:solid 3px #fcfcfc;"></div>'
                    );
                },
                stop: function (e, ui) {
                    var $uiItem = $(ui.item);
                    if ($uiItem.parent().is('#widgetGoogleMap'))
                        $uiItem.remove();
                },
            });
    });
    RVwys.widget.google = {};
    RVwys.panelGoogleMap = function (e) {
        parent.$('.wys-panel').hide(0, function () {
            parent.$('.wys-googleMapDesign').show();
        });
        var oMG = $(e).closest('.mg');
        var oFrame = oMG.find('iframe');
        //alert(oFrame.get(0))
        if (oFrame) {
            var oMap = oMG.find("[id^='widgetGoogleMaps']");
            // alert(oMG.get(0))
            parent.RVwys.curItemMap = oMap;
            const rowFame = $('<div/>').append(oFrame.clone());
            parent.$('.insert-embed-map').val(rowFame.html());

            parent.$('.mapInput').each(function () {
                const cmd = $(this).attr('cmd');
                $(this).val(oFrame.attr(cmd));
            });
        }
        $('.widgetGoogleProperties').hide();
        oMG.find('.widgetGoogleProperties').show();
    };
    RVwys.widget.google.sectionReceive = function (oThis, e, ui) {
        ui.sender.data('copied', true);
        var typeGoogle = ui.item.attr('googleValue');
        var thisTime = $.md5(String(e.timeStamp));
        var id = 'widgetGoogleMaps_' + thisTime;
        var placeHole =
            '<div class="rv-ribbon"></div><img src="' +
            parent.WYS_IMG_URL +
            'images/spacer.gif' +
            '"';
        placeHole += 'class="imgGoogleMaps"';
        placeHole += 'id="' + id + '"';
        placeHole +=
            'address="" inforwindow="Your Info" mapheight="200" view="roadmap" latCoordinates="51.5007309" longCoordinates="-0.1257197"';
        placeHole += 'align="center"';
        placeHole += 'formtype="googleMap"';
        placeHole +=
            'style="width:100%;height:200px;margin-left:3px;margin-right:3px;"';
        placeHole += 'onclick="RVwys.widget.google.showleftMenu(this)">';

        var designWidgetGoogleMaps = $('.designGoogleMap')
            .html()
            .replace(/#NAME#/gim, 'GoogleMaps')
            .replace(/#IMAGE#/gim, placeHole)
            .replace(/#ID#/gim, id)
            .replace(
                '#widgetGoogleMenuBar#',
                'widgetGoogleProperties navMenuAll'
            );

        ui.item.replaceWith(designWidgetGoogleMaps);
        $(oThis).parent().find('.dropHere').remove();

        setTimeout(function () {
            //var oMG = RVwys.getParentByClass($('#'+id),'mg');
            $('.mgActive').removeClass('mgActive');
            var oMG = $('#' + id).closest('.mg');
            oMG.find('.rvsb_design_block').addClass('mgActive');
            oMG.mousedown(function () {
                RVwys.eventClickblock($(this));
            });
            var tFoCus = oMG.eq(0);
            $('html, body').animate(
                {
                    scrollTop: tFoCus.offset().top,
                },
                1000,
                function () {
                    tFoCus.get(0).focus();
                }
            );
            parent.RVwys.curItemMap = $('#' + id);
            RVwys.currentEditor = document;
            RVwys.currentiFrame = tFoCus.get(0);
            //RVwys.uikit.blockprop.eventEditFocus(tFoCus);
            RVwys.panelGoogleMap($('#' + id));
        }, 100);
    };
})(jQuery);
